/** Audio settings (07 §5): four sliders, a mono toggle, and the "1987 score" option. Pure. */

export interface AudioSettings {
  master: number;
  music: number;
  sfx: number;
  ambience: number;
  mono: boolean;
  /** No in-mission music: title theme and touchdown reprise only, as in the original. */
  score1987: boolean;
}

export const DEFAULT_SETTINGS: AudioSettings = {
  master: 0.8, music: 0.7, sfx: 1, ambience: 0.8, mono: false, score1987: false,
};

const unit = (v: number, fallback: number): number => (Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : fallback);

/** `current` with `next` laid over it; sliders clamped to 0..1, junk ignored. */
export function mergeSettings(current: AudioSettings, next: Partial<AudioSettings>): AudioSettings {
  return {
    master: next.master !== undefined ? unit(next.master, current.master) : current.master,
    music: next.music !== undefined ? unit(next.music, current.music) : current.music,
    sfx: next.sfx !== undefined ? unit(next.sfx, current.sfx) : current.sfx,
    ambience: next.ambience !== undefined ? unit(next.ambience, current.ambience) : current.ambience,
    mono: next.mono ?? current.mono,
    score1987: next.score1987 ?? current.score1987,
  };
}

/** Sliders are perceptual: the gain applied is the square of the slider, so half-way sounds half as loud. */
export const sliderGain = (v: number): number => v * v;
